import React, {useEffect, useState} from 'react'
import {toggleQuickPanel} from "../../shared-components/quick-panel/store";
import history from "@history";
import {useDispatch, useSelector} from 'react-redux';
import {useRouteMatch} from "react-router-dom";
import PageHeader from "app/main/shared-components/page-header/PageHeader";
import {fetchAllAgents, fetchAllSubAgents} from "../store/agents-list.slice";
import {AppState} from "app/store";
import ModalDialog from "app/main/shared-components/modal-dialog/ModalDialog";
import {deleteAgent} from '../store/delete-agent.slice';
import PaginationBar from "../../shared-components/pagination-bar/PaginationBar";
import {clearfilterAgents, filterAgents} from "../store/filter-agents.slice";
import AgentsTable from "../../shared-components/agents-table/AgentsTable";
import {useTranslation} from "react-i18next";
import useAuthority from 'app/hooks/useAuthority';
import ScopesUtils from 'app/utils/ScopesUtils';
import {ROLES} from "app/constants/roles";

const AgentsList = () => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const [modal, setModal] = useState({state: false, deleteId: ''});
    const {allAgents, loading} = useSelector((state: AppState) => state.agents.allAgents);
     const {hasUserAnyAuthority} = useAuthority();
    const filtersAgents = useSelector((state: AppState) => state.agents.filAgents);
    const scopes = useSelector((state: AppState) => state.account.account.account?.scopes);
    const hasButton = ScopesUtils.AgentPremission(hasUserAnyAuthority, scopes);
    
    const isAdmin = hasUserAnyAuthority([ROLES.ROLE_ADMIN]);
    const isAgent = hasUserAnyAuthority([ROLES.ROLE_AGENT,ROLES.ROLE_CALL_AGENT]);
    
    useEffect(() => {
        // Admins see full agents list; agents see ONLY their sub-agents list.
        dispatch(isAgent ? fetchAllSubAgents() : fetchAllAgents());
        dispatch(clearfilterAgents());
    }, []);
    useEffect(() => {
    ScopesUtils.AgentPremission(hasUserAnyAuthority, scopes);
    }, [scopes]);

    const description = hasButton 
           ? (isAgent 
            ? t("app.main.agency.agentsList.subAgentDesc", "If you want to register a new sub-agent, click the Register button")
            : t("app.main.agency.agentsList.desc", "If you want to register a new agent or agency, click the Register button")) : " ";

    const pageTitle = isAgent 
        ? t("app.main.agency.agentsList.subAgentTitle", "Sub-Agents")
        : t("app.main.agency.agentsList.title", "Agents");

    return (
        <div>
            <PageHeader
                title={pageTitle}
                desc={description}
                button={hasButton ? t("app.main.agency.agentsList.registerButton", "Register") :false }
                onClickButton={() => {
                    history.push("/agents-agencies/list/create");
                    dispatch(toggleQuickPanel());
                }}
            />
            <ModalDialog
                open={modal.state}
                title='Are you sure you want to delete this?'
                onOk={() => {
                    dispatch(deleteAgent({id: modal.deleteId}));
                    setModal({state: false, deleteId: ''});
                }}
                onCancel={() => setModal({state: false, deleteId: ''})}
            />
            <AgentsTable data={allAgents} loading={loading}/>
            <PaginationBar totalPages={allAgents?.totalPages}
             onPageChange={(page: number) =>
             dispatch(filterAgents({...filtersAgents, page}))
                           }/>

        </div>
    )
}

export default AgentsList;